<template>
  <div>
    <BaseSectionHeader class="pt-4 md:pt-0 border-t md:border-t-0 border-strong-shadow-color">
      {{ $t('Investment entities') }}
    </BaseSectionHeader>
    <BaseEditableList
      :items="transformedEntities"
      add-title="Ajouter une entité d'investissement"
      class="mb-16"
      @add="onEntityAdd"
    />
  </div>
</template>

<script>
import { mapState } from 'vuex';
import BaseSectionHeader from '../../components/BaseSectionHeader.vue';
import BaseEditableList from '../../components/BaseEditableList.vue';
import { RESET } from '../../store/mutation-types';

export default {

  name: 'ProfileInvestmentEntities',
  components: {
    BaseSectionHeader,
    BaseEditableList,
  },

  computed: {
    ...mapState('investmentEntity', {
      investmentEntities: 'list',
    }),
    transformedEntities() {
      return this.investmentEntities.map(entity => ({
        id: entity.id,
        title: entity.attributes.name,
        action: {
          title: 'Modifier',
          to: `investment-entities/${entity.attributes.kind}/${entity.id}/edit`,
        },
      }));
    },
  },
  methods: {
    onEntityAdd() {
      this.$store.commit(`investmentEntity/${RESET}`);
      this.$router.push('/investment-entities/new');
    },
  },
};
</script>
